export default __webpack_public_path__ + "static/media/15-face-with-raised-eyebrow_1f928.aae859ab.png";